module.exports = __webpack_public_path__ + "static/img/service_introduce_head_zh.e9f75b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/service_introduce_head_zh.png
// module id = q2u6
// module chunks = 34